/**
 * Tenant Detection Utility
 *
 * Extracts tenant identifier from the current hostname (subdomain).
 * Used to determine which tenant configuration to load.
 *
 * Examples:
 * - client1.sistema.com → "client1"
 * - localhost → "demo" (development fallback)
 * - sistema.com → "default" (no subdomain)
 */

import { log } from './DebugLogger'

export function detectTenantSubdomain(): string {
  const hostname = window.location.hostname

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    log('TenantDetection', 'detectTenantSubdomain', 'Development mode detected, using "demo" tenant')
    return 'demo'
  }

  const parts = hostname.split('.')

  if (parts.length >= 3) {
    const subdomain = parts[0]
    log('TenantDetection', 'detectTenantSubdomain', `Subdomain detected: "${subdomain}"`)
    return subdomain
  }

  log('TenantDetection', 'detectTenantSubdomain', 'No subdomain detected, using "default" tenant')
  return 'default'
}

export function getCurrentHostname(): string {
  return window.location.hostname
}

export function isDevelopmentMode(): boolean {
  const hostname = window.location.hostname
  return hostname === 'localhost' || hostname === '127.0.0.1'
}
